<script setup lang="ts">
import { __ } from '@@/bits/intl'
import type { OzContainedButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonHrefMode } from '@@/library/v4/components/OzIconButton.vue'
withDefaults(
  defineProps<{
    darkMode?: boolean | 'auto'
    disabled?: boolean
    /**
     * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
     */
    href?: string
    /**
     * See `OzBaseButton`.
     */
    hrefMode?: OzIconButtonHrefMode
    /** See `OzContainedButton`. */
    sizePreset?: OzContainedButtonSizePreset
    colorScheme?: OzIconButtonColorScheme
    closeIconSize?: 'default' | 'small'
    label?: string
  }>(),
  {
    darkMode: 'auto',
    disabled: false,
    href: undefined,
    hrefMode: OzIconButtonHrefMode.Default,
    sizePreset: undefined,
    colorScheme: OzIconButtonColorScheme.Secondary,
    label: __('Close'),
    closeIconSize: 'default',
  },
)

defineEmits(['click'])
</script>

<script lang="ts">
export { OzIconButtonHrefMode as OzCloseButtonHrefMode } from '@@/library/v4/components/OzIconButton.vue'
export { OzContainedButtonSizePreset as OzCloseButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
export { OzIconButtonColorScheme as OzCloseButtonColorScheme } from '@@/library/v4/components/OzIconButton.vue'

export default {}
</script>

<template>
  <OzIconButton
    :dark-mode="darkMode"
    :label="label"
    :href="href"
    :href-mode="hrefMode"
    :color-scheme="colorScheme"
    :size-preset="sizePreset"
    :disabled="disabled"
    :icon-name="closeIconSize === 'default' ? 'close' : 'close_small'"
    @click="$emit('click', $event)"
  />
</template>
